import { api, getWithOptionalAuthorizationGeneric, putWithOptionalAuthorization } from './api';
import { POI_BASE, SECTION_BASE } from './apiConstant';
import { getToken } from './auth';
import { decryptMessage } from '../utils/decrypt';

export type POIResponse = {
  id: string;
  business: string;
  businessTypeID: string;
  poiTypeID: string | null;
  type: number;
  cityID: string;
  location: string;
  contact: string;
  centreCoordinate: [string, string]; // tuple of lat/long
  markerPoint: string; // JSON string from backend
  createdAt: string;   // ISO date string
  updatedAt: string | null;
  businessTypeName: string;
  poiTypeName: string | null;
  winterDescription: string;
  summerDescription: string;
  sortOrder: number | null;
};

export type POIData = {
  id: string;
  name: string;
};


const poiApi = {

  getPOIByCity: async (cityId: string): Promise<POIResponse> => {
    try {
      const encryptedContestResponse = await getWithOptionalAuthorizationGeneric<POIResponse[]>
        (`${POI_BASE}/GetAll/${cityId}`, true);
      const getCityResponse = await decryptMessage(encryptedContestResponse.data.Data, getToken());
      return getCityResponse;
    } catch (error) {
      console.error('Error fetching pois by city Id:', error);
      throw error;
    }
  },


  saveReorderCitys: async (payload: {
  }): Promise<any> => {
    try {
      const response = await putWithOptionalAuthorization(
        `${SECTION_BASE}/ReArrangeCities`,
        payload,
        true,
        false,
      );

      return response.data;
    } catch (error) {
      console.error("Error saving reordered Citys:", error);
      console.log(error.response);
      throw error;
    }
  },

  saveReorderPOIs: async (payload: {
  }): Promise<any> => {
    try {
      const response = await putWithOptionalAuthorization(
        `${SECTION_BASE}/ReArrangeRegionPOIs`,
        payload,
         true,
        false,
      );
      return response.data;
    } catch (error) {
      console.error("Error saving reordered POIs:", error);
      console.log(error.response);
      throw error;
    }
  },


};

export default poiApi;